import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
// import cook from "../../../assets/Images/cook.svg";
// import carWasher from "../../../assets/Images/carWasher.svg";
// import milk from "../../../assets/Images/milk.svg";
// import maid from "../../../assets/Images/maid.svg";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import avtarPic from "../../../assets/Images/avtarPic.png";
import moment from "moment";

import swal from "sweetalert";

import { makePostRequest } from "../../../utils/utils";

function ServiceProviderHistory() {
  // const navigate = useNavigate();

  // const [alignment, setAlignment] = React.useState("Maids");
  // const handleAlignment = (event, newAlignment) => {
  //   setAlignment(newAlignment);
  // };

  const [selected, setSelected] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [q, setQ] = React.useState("");
  // const [status, setStatus] = React.useState("");
  // const [length, setlength] = React.useState();
  const [sortBy] = React.useState("");
  const [historyAndReviewList, setHistoryAndReviewList] = React.useState([]);
  const [serviceTypeList, setServiceTypeList] = React.useState([]);
  const [selectedServiceType, setSelectedServiceType] = React.useState("");
  const [selectedServiceProviderId, setSelectedServiceProviderId] =
    React.useState();
  const [serviceProvidersList, setServiceProvidersList] = React.useState([]);

  // const [Upload, setUpload] = React.useState(false);

  async function handleChangeServiceType(serviceType) {
    setSelectedServiceType(serviceType);
    await ActiveServiceProviderListing(serviceType);
    // await HistoryAndReviewListing(serviceType);
  }

  async function handleChangeServiceProvider(serviceProviderId) {
    setSelectedServiceProviderId(serviceProviderId);
    await HistoryAndReviewListing(serviceProviderId);
  }

  async function ServiceTypeListing() {
    setShowLoader(true);
    let serviceType = "";
    let bodyFormData = {
      sortBy: "ASC",
      status: true,
    };

    await makePostRequest("servicetype/getalllisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("ServiceType  Data");
          console.log(response.data.data.rows);
          setServiceTypeList(response.data.data.rows);
          setSelectedServiceType(response.data.data.rows[0].service_name);
          serviceType = response.data.data.rows[0].service_name;
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
    await ActiveServiceProviderListing(serviceType);
  }

  async function ActiveServiceProviderListing(serviceType) {
    setShowLoader(true);
    let serviceProviderId;

    let bodyFormData = {
      sortBy: "ASC",
      searchq: q,
      serviceType: serviceType,
    };

    await makePostRequest("serviceProvider/getallactive", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log("ServiceType  Data");
          console.log(response.data.data.length);
          if (response.data.data.length > 0) {
            setServiceProvidersList(response.data.data);
            setSelectedServiceProviderId(
              response.data.data[0].service_provider_id
            );
            HistoryAndReviewListing(response.data.data[0].service_provider_id);
          } else {
            setHistoryAndReviewList([]);
            setServiceProvidersList([]);
            setSelectedServiceProviderId();
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }

  async function HistoryAndReviewListing(serviceProviderId) {
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      sortBy: sortBy,
      serviceProviderId: serviceProviderId,
    };

    await makePostRequest(
      "serviceproviderhistory/GetAllServiceProviderHistoryAndReviews",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log("HistoryAndReview  Data");
          console.log(response.data.data);
          setHistoryAndReviewList(response.data.data);
          // setHistoryObj(response.data.data.)
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false);
      });
  }

  async function handleChangeSearch(searchString) {
    setQ(searchString);
    await ActiveServiceProviderListing(selectedServiceType);
  }

  React.useEffect(() => {
    ServiceTypeListing();
  }, []);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Dashboard")}
              /> */}
              Service Provider History
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="serviceisoryMain">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <h4 className="servicHistCateHead">Service Provider Types</h4>
                  {/* <ToggleButtonGroup
                    value={alignment}
                    exclusive
                    onChange={handleAlignment}
                    className="categServiceProBtOuter"
                  >
                    {serviceTypeList.map((option) => (
                      <ToggleButton
                        value="Maids"
                        className="serviceCateoryBtn"
                        onClick={() =>
                          handleChangeServiceType(option.service_name)
                        }
                      >
                        {option.profile_pic ? (
                          <img src={option.profile_pic} />
                        ) : (
                          <></>
                        )}
                        {option.service_name}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup> */}

                  <div className="categServiceProBtOuter">
                    {serviceTypeList.map((option) => (
                      <Button
                        className={selectedServiceType==option.service_name?"serviceCateoryBtn activeCat":"serviceCateoryBtn"}
                        onClick={() =>
                          handleChangeServiceType(option.service_name)
                        }
                      >
                        {option.profile_pic ? (
                          <img src={option.profile_pic} />
                        ) : (
                          <></>
                        )}
                        {option.service_name}
                      </Button>
                    ))}
                  </div>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <div
                        className="visitorSearch"
                        style={{ marginBottom: 0 }}
                      >
                        <div className="visitorSearchDiv">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search"
                            onChangeCapture={(e) =>
                              handleChangeSearch(e.target.value)
                            }
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        <div className="sortingIcoOut">
                          <ToggleButton
                            value="check"
                            selected={selected}
                            onChange={() => {
                              setSelected(!selected);
                            }}
                          >
                            <ImportExportIcon
                              className="visitorFilterIco"
                              // aria-controls={open ? "basic-menu" : undefined}
                              aria-haspopup="true"
                              // aria-expanded={open ? "true" : undefined}
                              // onClick={(e) => handleChangeSortBy(e, "Tenent")}
                            />
                          </ToggleButton>
                        </div>
                      </div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <div className="historyListMain">
                        {serviceProvidersList.map((serviceProvider) => (
                          <div
                            className={
                              selectedServiceProviderId ==
                              serviceProvider.service_provider_id
                                ? "visitContDiv selectHistoryList"
                                : "visitContDiv"
                            }
                            onClick={(e) =>
                              handleChangeServiceProvider(
                                serviceProvider.service_provider_id
                              )
                            }
                          >
                            <div className="visitCont1 resideNewContOut">
                              <div className="visitContProf linkCOnt">
                                <img src={avtarPic} />
                              </div>
                              <div className="visitContLeft linkCOnt">
                                <h3 className="visitContHed">
                                  {serviceProvider.firstname}{" "}
                                  {serviceProvider.lastname}
                                </h3>
                                <p className="visitContMob">
                                  {serviceProvider.contactno}
                                </p>
                              </div>
                              {serviceProvider.registeged_date ? (
                                <div className="historyDateTx">
                                  <label>Registered Since</label>
                                  <p>
                                    {moment(
                                      serviceProvider.registeged_date
                                    ).format("DD-MM-YYYY")}
                                  </p>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Grid>
                    {historyAndReviewList.length > 0 ? (
                      <Grid item xs={12} md={8}>
                        <div className="historyDetailsMain">
                          <div className="outerHistory">
                            {historyAndReviewList.map((history) => (
                              <div>
                                {history.is_service_stopped ? (
                                  <>
                                    <h1 className="historyHead">Working History</h1>
                                    <div className="visitContDiv">
                                      <div className="visitCont1 resideNewContOut buildingNameNcountMain">
                                        {history.resident[0].apartments.map(
                                          (option) => (
                                            <>
                                              {(history.resident[0].user_type ==
                                                "Resident User" &&
                                                option.is_current_stay ==
                                                  true) ||
                                              history.resident[0].user_type ==
                                                "tenent" ? (
                                                <div className="NewTailCountOut forTenantColor">
                                                  <div className="buildingNameNcount">
                                                    <p>
                                                      {
                                                        option.uniq_apt_name.split(
                                                          "/"
                                                        )[0]
                                                      }
                                                    </p>
                                                    <p>
                                                      {
                                                        option.uniq_apt_name.split(
                                                          "/"
                                                        )[1]
                                                      }
                                                    </p>
                                                  </div>
                                                  <h1>
                                                    {
                                                      option.uniq_apt_name.split(
                                                        "/"
                                                      )[2]
                                                    }
                                                  </h1>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )
                                        )}
                                        <div className="visitContProf linkCOnt">
                                          <img src={avtarPic} />
                                        </div>
                                        <div className="visitContLeft linkCOnt">
                                          <h3 className="visitContHed">
                                            {
                                              history.resident[0].user_obj
                                                .first_name
                                            }{" "}
                                            {
                                              history.resident[0].user_obj
                                                .last_name
                                            }
                                          </h3>
                                          <p className="visitContMob">
                                            {
                                              history.resident[0].user_obj
                                                .contact_no
                                            }
                                          </p>
                                          <p className="visitContTime forImailAlig">
                                            {
                                              history.resident[0].user_obj
                                                .email_id
                                            }
                                          </p>
                                        </div>
                                        <div className="visitBottCont">
                                          <p>From Date</p>
                                          <b>
                                            {moment(
                                              history.service_start_date
                                            ).format("DD-MM-YYYY")}
                                          </b>
                                        </div>
                                        {history.service_end_date ? (
                                          <div className="visitBottCont">
                                            <p>From Date</p>
                                            <b>
                                              {moment(
                                                history.service_end_date
                                              ).format("DD-MM-YYYY")}
                                            </b>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <h1 className="historyHead">
                                      Currently Working{" "}
                                    </h1>

                                    <div className="visitContDiv">
                                      <div className="visitCont1 resideNewContOut buildingNameNcountMain">
                                        {history.resident[0].apartments.map(
                                          (option) => (
                                            <>
                                              {(history.resident[0].user_type ==
                                                "Resident User" &&
                                                option.is_current_stay ==
                                                  true) ||
                                              history.resident[0].user_type ==
                                                "tenent" ? (
                                                <div className="NewTailCountOut forTenantColor">
                                                  <div className="buildingNameNcount">
                                                    <p>
                                                      {
                                                        option.uniq_apt_name.split(
                                                          "/"
                                                        )[0]
                                                      }
                                                    </p>
                                                    <p>
                                                      {
                                                        option.uniq_apt_name.split(
                                                          "/"
                                                        )[1]
                                                      }
                                                    </p>
                                                  </div>
                                                  <h1>
                                                    {
                                                      option.uniq_apt_name.split(
                                                        "/"
                                                      )[2]
                                                    }
                                                  </h1>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )
                                        )}
                                        <div className="visitContProf linkCOnt">
                                          <img src={avtarPic} />
                                        </div>
                                        <div className="visitContLeft linkCOnt">
                                          <h3 className="visitContHed">
                                            {
                                              history.resident[0].user_obj
                                                .first_name
                                            }{" "}
                                            {
                                              history.resident[0].user_obj
                                                .last_name
                                            }
                                          </h3>
                                          <p className="visitContMob">
                                            {
                                              history.resident[0].user_obj
                                                .contact_no
                                            }
                                          </p>
                                          <p className="visitContTime forImailAlig">
                                            {
                                              history.resident[0].user_obj
                                                .email_id
                                            }
                                          </p>
                                        </div>
                                        <div className="visitBottCont">
                                          <p>From Date</p>
                                          <b>
                                            {moment(
                                              history.service_start_date
                                            ).format("DD-MM-YYYY")}
                                          </b>
                                        </div>
                                        {history.service_end_date ? (
                                          <div className="visitBottCont">
                                            <p>From Date</p>
                                            <b>
                                              {moment(
                                                history.service_end_date
                                              ).format("DD-MM-YYYY")}
                                            </b>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </Grid>
                    ) : (
                      <span>No Service Provider History</span>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ServiceProviderHistory;
